/** Wraps a route so it only renders when access.under_management is true. */
import { usePortalAccess } from "../../contexts/PortalAccessContext";
import AccessLockedScreen from "./AccessLockedScreen";

export default function ManagementGuard({ children }) {
  const { access, loading } = usePortalAccess();
  if (loading) return null;
  if (!access.under_management) {
    return (
      <AccessLockedScreen
        testId="management-locked"
        titleKey="portal.locked.management_title"
        messageKey="portal.locked.management_msg"
      />
    );
  }
  return children;
}
